import { shutdown } from "@intercom/messenger-js-sdk";
import { authService } from "@/services/auth";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";

export default function useSignOutUser() {
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	const signOut = () => {
		// Kill Intercom session so the widget doesn't show the previous user's name
		shutdown();

		authService.clearToken();
		navigate({ to: "/", search: { promo: undefined } });
		queryClient.clear();
	};

	return { signOut };
}
